<template>
  <div class="root">
    <div class="blocc" v-for="comments in messages" :key="comments[0].uid">
      <EstablishmentStateComments
          :comments="comments"
          :read-only="true"
      />
    </div>
    <span v-if="messages.length === 0">Aucun échange à afficher</span>
  </div>
</template>

<script>
import ALL_MESSAGE_FOR_REVIEW from '@/gql/queries/allMessageForReview.graphql';
import { gqlQuery } from '@/gqlClient.js';
import EstablishmentStateComments from '@/components/EstablishmentStateComments'

export default {
  name: "EstablishmentAllMessage",
  components: {EstablishmentStateComments},
  props: {
    review: {
      type: Object
    },
    currentState: {
      type: Object
    }
  },
  data() {
    return {
      messages: []
    }
  },
  async mounted() {
    const resp = await gqlQuery(ALL_MESSAGE_FOR_REVIEW, { review_uid: this.review.uid })
    if (this.currentState) {
      this.messages = resp.body.data.all_message_review.messages.filter(
          stateMessages =>
              stateMessages.length > 0 && stateMessages[0].state_uid !== this.currentState.uid
      )
    } else {
      this.messages = resp.body.data.all_message_review.messages
    }
  }
}
</script>